import React from "react";

const Keywords = ({ ocr_results }) => {

  return (
    <>
      <div className="table-responsive m-3">
        <table className="table table-striped table-hover table-bordered table-no-outer-border">
          <tbody>
            {ocr_results?.map((data, index) => (
              <React.Fragment key={index}>
                {index % 5 === 0 && index !== 0 && (
                  <tr>
                    {ocr_results
                      .slice(index - 5, index)
                      .map((innerData, innerIndex) => (
                        <React.Fragment key={innerIndex}>
                          {innerData.result === "Matched" ? (
                            <td
                              style={{
                                width: "200px",
                                fontSize: "14px",
                                backgroundColor: "lightgreen",
                              }}
                            >
                              <b>
                                {innerData.type ? innerData.type : "Keyword"}
                              </b>{" "}
                              <br /> {innerData.keyword}
                            </td>
                          ) : (
                            <td
                              style={{
                                width: "200px",
                                fontSize: "14px",
                                backgroundColor: "#f48989",
                              }}
                            >
                              <b>
                                {innerData.type ? innerData.type : "Keyword"}
                              </b>{" "}
                              <br /> {innerData.keyword}
                            </td>
                          )}
                        </React.Fragment>
                      ))}
                  </tr>
                )}
                {index === ocr_results.length - 1 && (
                  <tr>
                    {ocr_results
                      .slice(index - (index % 5), index + 1)
                      .map((innerData, innerIndex) => (
                        <React.Fragment key={innerIndex}>
                          {innerData.result === "Matched" ? (
                            <td
                              style={{
                                width: "200px",
                                fontSize: "14px",
                                backgroundColor: "lightgreen",
                              }}
                            >
                              <b>
                                {innerData.type ? innerData.type : "Keyword"}
                              </b>{" "}
                              <br /> {innerData.keyword}
                            </td>
                          ) : (
                            <td
                              style={{
                                width: "200px",
                                fontSize: "14px",
                                backgroundColor: "#f48989",
                              }}
                            >
                              <b>
                                {innerData.type ? innerData.type : "Keyword"}
                              </b>{" "}
                              <br /> {innerData.keyword}
                            </td>
                          )}
                        </React.Fragment>
                      ))}
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Keywords;
